import React, { ReactNode } from 'react';

interface EmptyStateWithIconProps {
  message: string;
  /** Kept for backwards compatibility; no longer rendered. */
  icon?: ReactNode;
  /** Optional secondary line below the message. */
  description?: string;
}

/**
 * Unified empty state for the contact activity tabs (Calls, Emails, SMS,
 * Website, Notes, Homeowner). Plain centered text — message + optional
 * subtext — one consistent look everywhere.
 */
export const EmptyStateWithIcon: React.FC<EmptyStateWithIconProps> = ({
  message,
  description,
}) => {
  return (
    <div className="text-center py-12 px-4">
      <p className="text-sm font-medium text-foreground/80">{message}</p>
      {description && (
        <p className="text-xs text-muted-foreground mt-1 max-w-xs mx-auto">{description}</p>
      )}
    </div>
  );
};
